import type { ProgramItem } from "@tih/shared";
import { useReveal } from "../hooks/useReveal";

const FALLBACK: ProgramItem[] = [
  { time: "9:30 PM", title: "Gathering & Opening Prayer", note: "Led by the Pastoral team" },
  { time: "10:00 PM", title: "First Set — Songs of Ascent", note: "Dorothy & the Upper Room Band" },
  { time: "11:30 PM", title: "The Word", note: "A short, steady reading" },
  { time: "12:00 AM", title: "Second Set — Deep Waters", note: "Intercession & spontaneous worship" },
  { time: "2:00 AM", title: "The Quiet Hour", note: "Acoustic · candlelight · stillness" },
  { time: "3:00 AM", title: "Third Set — Victory & Jubilee", note: "Full band, loud and glad" },
  { time: "4:30 AM", title: "Communion", note: "Served slowly, together" },
  { time: "5:00 AM", title: "Sunrise Benediction", note: "A blessing for the road home" },
];

export function Program({ items = FALLBACK }: { items?: ProgramItem[] }) {
  const ref = useReveal<HTMLElement>();
  return (
    <section className="section section-program" id="program" ref={ref}>
      <div className="prog-head">
        <div className="sec-eyebrow"><em>the program</em></div>
        <h2 className="sec-title">Eight hours, unbroken.</h2>
        <p className="lede-serif">A rough map of the night. Times bend to the room — the Spirit keeps better time than we do.</p>
      </div>
      <ol className="program">
        {items.map((p) => (
          <li key={p.time + p.title}>
            <span className="pr-time">{p.time}</span>
            <span className="pr-title">{p.title}</span>
            <span className="pr-note">{p.note}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
